<template>
  <v-app>
    <v-container class="grey lighten-5">
      <v-row class="justify-center">
        <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
          <p>Carregando...</p>
          <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
        </div>
        <v-col class="col-12 col-md-10" v-if="!isLoading">
          <h2 class="text-center text-md-left primary--text ml-md-4">
            <v-icon class="primary--text mr-2">calendar_today</v-icon>Detalhe da Consulta
          </h2>

          <div class="row justify-center">
            <div class="col-12 col-md-5">
              <div
                class="box-item custom-radius bg-yellow d-flex flex-row align-center justify-space-between px-3 py-4"
              >
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">record_voice_over</v-icon>
                  <p class="ma-0 mr-2 gray--text">{{details.patient.name}}</p>
                </div>
                <v-btn class="bt-perfil" @click="goProfilePatients(details.patient.id)">Ver Perfil</v-btn>
              </div>
              <div
                class="box-item border-bottom d-flex flex-row align-center justify-space-between px-3 py-4"
              >
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">calendar_today</v-icon>
                  <p class="ma-0 mr-2 gray--text">{{ details.date | formatDate }}</p>
                </div>
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">access_time</v-icon>
                  <p class="ma-0 mr-2 gray--text">{{ details.time | formatDateTZ(details.date) }}</p>
                </div>
              </div>
              <!-- <div class="box-item border-bottom px-3 py-4">
                <p class="ma-0 gray--text text-center obs-text">
                  <strong>Obs:</strong> Esse paciente contratou mais 11 consultas com você.
                </p>
              </div>-->
              <div
                class="box-item bg-gray d-flex flex-row align-center justify-center pa-3 mt-3 custom-radius"
              >
                <!-- <v-icon class="secondary--text mr-2">attach_money</v-icon> -->
                <p class="ma-0 mr-2 gray--text">
                  <strong>Valor da Consulta:</strong>
                </p>
                <p class="ma-0 mr-2 secondary--text valor-consulta">{{value}}</p>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <p class="ma-0 mr-2 gray--text text-center text-md-left">
                <strong>Contatos</strong>
              </p>
              <div
                class="box-item bg-gray custom-radius d-flex flex-row align-center justify-space-between px-3 py-4"
              >
                <p class="ma-0 gray--text">
                  <strong>Telefone/WhatsApp</strong>
                </p>
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="secondary--text">local_phone</v-icon>
                  <div class="whats-img ml-2">
                    <v-img :src="require('../../assets/logo-whatsapp.svg')" width="32px"></v-img>
                  </div>
                </div>
                <p class="ma-0 mr-2 gray--text text-center">
                  <strong>{{details.patient.telephone}}</strong>
                </p>
              </div>
              <div
                class="box-item bg-gray custom-radius d-flex flex-row align-center justify-space-start px-3 py-4 mt-3"
              >
                <p class="ma-0 gray--text">
                  <strong>Skype</strong>
                </p>
                <div class="skype-img ml-2">
                  <v-img :src="require('../../assets/logo-skype.svg')" width="32px"></v-img>
                </div>
                <p class="ma-0 ml-2 gray--text text-center">
                  <strong>{{details.patient.skype}}</strong>
                </p>
              </div>
              <div
                class="box-item bg-gray custom-radius d-flex flex-row align-center justify-space-start px-3 py-4 mt-3"
              >
                <p class="ma-0 gray--text">
                  <strong>Email</strong>
                </p>
                <v-icon class="gray--text ml-2" size="30">email</v-icon>
                <p class="ma-0 ml-2 gray--text text-center">
                  <strong>{{details.patient.email}}</strong>
                </p>
              </div>
              <div
                class="box-item bg-gray custom-radius d-flex flex-row align-center justify-space-start px-3 py-4 mt-3"
              >
                <p class="ma-0 gray--text">
                  <strong>Hangout</strong>
                </p>
                <div class="skype-img ml-2">
                  <v-img :src="require('../../assets/icon-hangout.svg')" width="32px"></v-img>
                </div>
                <p class="ma-0 ml-2 gray--text text-center">
                  <strong>{{details.patient.hangouts}}</strong>
                </p>
              </div>
            </div>
          </div>
          <div class="row justify-start">
            <div
              class="col-12 col-md-3 text-center"
              v-if="videoCall.video_call_status == 'NONE' && details.status == 'SCHEDULED' && canShowStartCall"
            >
              <v-dialog v-model="confirmVideoDialog" max-width="400">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    v-on="on"
                    class="white--text"
                    height="50"
                    min-width="100%"
                  >Iniciar chamada</v-btn>
                </template>
                <v-card>
                  <v-card-title class="headline">Iniciar Video Chamada</v-card-title>
                  <v-card-text>
                    <div class="text-center">
                      <p>Deseja mesmo iniciar a chamada?</p>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-end">
                    <v-btn
                      color="gray lighthen-1"
                      text
                      @click="confirmVideoDialog = false"
                    >Não Obrigado</v-btn>
                    <v-btn color="primary" text @click="initializeVideoCall()">Sim</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
            <div
              class="col-12 col-md-3 text-center"
              v-if="details.status == 'SCHEDULED' && canShowCancelButton && isInCall === false"
            >
              <v-dialog v-model="dialog" max-width="400">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    v-on="on"
                    class="white--text"
                    height="50"
                    min-width="100%"
                  >Cancelar</v-btn>
                </template>
                <v-card>
                  <v-card-title class="headline">Cancelar consulta!</v-card-title>
                  <v-card-text>
                    <div class="text-center">
                      <p>Informe aqui o motivo do cancelamento.</p>
                      <v-textarea
                        solo
                        flat
                        no-resize
                        background-color="#F7F7F7"
                        rows="8"
                        v-model="justification"
                      ></v-textarea>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-end">
                    <!-- <v-btn color="gray darken-1" text @click="dialog = false">Não Obrigado</v-btn> -->
                    <v-btn
                      color="primary darken-1"
                      text
                      :disabled="isDisabled"
                      @click="cancelConsultation()"
                    >Ok</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
            <!-- FINALIZAR -->
            <div
              class="col-12 col-md-3 text-center"
              v-if="details.status == 'SCHEDULED' && canShowStartCall && isInCall === false"
            >
              <v-btn
                color="primary"
                height="50"
                min-width="100%"
                @click="doneConsultation()"
              >Finalizar</v-btn>
            </div>
          </div>
          <!-- INICIA VIDEO -->
          <v-row>
            <v-col>
              <div class="col-12 col-md-3 text-center" v-if="isInCall">
                <v-dialog v-model="confirmVideoDialog" max-width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" height="50" min-width="100%" v-on="on">Parar chamada</v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline">Finalizar Video Chamada</v-card-title>
                    <v-card-text>
                      <div class="text-center">
                        <p>Deseja mesmo terminar a chamada?</p>
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-end">
                      <v-btn
                        color="gray lighthen-1"
                        text
                        @click="confirmVideoDialog = false"
                      >Não Obrigado</v-btn>
                      <v-btn color="primary" text @click="stopVideoCall()">Sim</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-col>
            <v-col :cols="3" v-if="isInCall">
              <div class="d-flex flex-row align-center justify-center">
                <v-icon class="primary--text mr-2">timer</v-icon>
                <div>
                  <countdown :end-time="endDate.toDate()" />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="iframe" v-if="isInCall">
        <iframe
          :src="`${videoCall.video_call_url}?embed&iframeSource=ondivan&displayName=${details.psychologist_name}&screenshare=off&background=off`"
          :style="{width: '100%', height: '120%', backgroundImage: `url(${require('../../assets/icon_ondivan_red.svg')})`,backgroundSize: 'cover'}"
          allow="camera, microphone, fullscreen, speaker"
        />
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Vue from 'vue';
import http from '@/services/httpClient';
import countdown from '@/components/Countdown';
import moment from 'moment-timezone';
import { getDetails } from '../../services/psychologists';

export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      time: new Date().toTimeString().substr(0, 8),
      nowDateTime: moment(),
      cod: '',
      details: {
        date: String,
        id: String,
        patient: {},
        psychologist_name: String,
        psychologist: Number,
        status: String,
        time: String,
        dateTime: String,
      },
      value: '',
      justification: '',
      videoCall: {
        video_call_url: String,
        video_call_status: String,
        video_call_id: Number,
      },
      isInCall: false,
      confirmVideoDialog: false,
      dialog: false,
      isDisabled: true,
      isLoading: true,
      endDate: moment(),
    };
  },
  components: { countdown },
  async created() {
    await this.getCod();
    await this.loadDetails();
    await this.loadCallDetails();
    this.getValue();
  },
  watch: {
    justification(val) {
      val ? (this.isDisabled = false) : (this.isDisabled = true);
    },
  },
  computed: {
    localDateTime() {
      const userData = localStorage.getItem('user-data');
      const timeZone = JSON.parse(userData).time_zone_name;
      return moment
        .utc(`${this.details.date} ${this.details.time}`)
        .tz(String(timeZone));
    },
    canShowStartCall() {
      return this.localDateTime.isSameOrBefore(this.nowDateTime);
    },
    canShowCancelButton() {
      return this.nowDateTime.isSameOrBefore(this.localDateTime);
    },
  },
  methods: {
    getCod() {
      this.cod = localStorage.getItem('user-id');
    },
    async loadDetails() {
      const { id } = await this.$route.params;
      try {
        const { data } = await getDetails(this.cod, id);
        this.details = data;
        this.details.dateTime = data.date.concat('T', data.time);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async loadCallDetails() {
      const result = await http.get(
        `/appointments/${this.details.id}/video_call`,
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      );
      this.videoCall = result.data;
      if (this.videoCall.video_call_status === 'OPEN') {
        this.isInCall = true;
      }
    },
    goProfilePatients(id) {
      console.log(id);
      this.$router.push({ name: 'PacienteProfile', params: { id } });
    },
    doneConsultation() {
      const { id } = this.$route.params;
      http
        .post(
          `/psychologists/${this.cod}/appointments/${id}/closing/`,
          {},
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        )
        .then((response) => {
          const { data, status } = response;
          if (status == 200) {
            this.details = data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getValue() {
      const user = await JSON.parse(localStorage.getItem('user-data'));
      this.value = user.appointment_pt_value != '0.00'
        ? `€ ${user.appointment_pt_value}`
        : `R$ ${user.appointment_br_value}`;
    },
    cancelConsultation() {
      http
        .post(
          `/psychologists/${this.cod}/appointments/${this.details.id}/cancellation/`,
          {
            comments: this.justification,
          },
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        )
        .then((response) => {
          const { data, status } = response;
          if (status == 200) {
            this.details = data;
            // this.$router.replace(`/psicologo/scheduling/${this.details.psychologist.id}`)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async initializeVideoCall() {
      this.confirmVideoDialog = false;
      const videoResult = await http.get(
        `/psychologists/${this.cod}/appointments/${this.details.id}/start_video`,
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      );

      this.endDate = moment().add(50, 'minutes');
      this.videoCall = videoResult.data;
      this.isInCall = true;
    },
    async stopVideoCall() {
      const videoResult = await http.get(
        `/psychologists/${this.cod}/appointments/${this.details.id}/stop_video`,
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      );
      this.doneConsultation();

      this.videoCall = videoResult.data;
      this.isInCall = false;
    },
  },
};
</script>

<style lang="css" scoped>
/* .toolbar {
  height: auto;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
} */

.box-item {
  width: 100%;
}

.custom-radius {
  border-radius: 5px;
}

.bg-yellow {
  background-color: #fffde3;
}

.bg-gray {
  background-color: #e0e0e0;
}

.border-bottom {
  border-bottom: 1px solid #ccc;
}

.bt-perfil {
  font-size: 0.5rem;
}

.obs-text {
  font-size: 0.8rem;
}

.valor-consulta {
  font-size: 1.3rem;
}

.whats-img,
.whats-img .v-image__image--cover {
  width: 25px;
  height: 25px;
}

.skype-img,
.skype-img .v-image__image--cover {
  width: 25px;
  height: 25px;
}

.email-img,
.email-img .v-image__image--cover {
  width: 30px;
  height: 30px;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.iframe {
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
}
</style>
